import { inventoryUnitOptions, inventoyCategoryOptions } from "./choices";

// Table columns for Appointment list view
export const inventoryTableColumns = [
  { key: "name", name: "name", label: "Name" },
  {
    key: "category",
    name: "category",
    label: "Category",
    type: "select",
    options: inventoyCategoryOptions,
  },
  {
    key: "unit",
    name: "unit",
    label: "Unit",
    type: "select",
    options: inventoryUnitOptions,
  },
  { key: "quantity", name: "quantity", label: "Quantity", type: "number" },
  {
    key: "reorderLevel",
    name: "reorderLevel",
    label: "Reorder Level",
    type: "number",
  },
  { key: "expiryDate", name: "expiryDate", label: "Expiry Date", type: "date" },
  { key: "created_on", name: "created_on", label: "Created", type: "date" },
];

// Form fields with conditional visibility
export const inventoryFormFields = [
  {
    name: "name",
    label: "Name",
    type: "text",
    showOn: "all",
    required: true,
  },
  {
    name: "category",
    label: "Category",
    type: "select",
    options: inventoyCategoryOptions,
    showOn: "all",
    required: true,
  },
  {
    name: "unit",
    label: "Unit",
    type: "select",
    options: inventoryUnitOptions,
    showOn: "all",
    required: true,
  },
  // {
  //   name: "quantity",
  //   label: "Quantity",
  //   type: "number",
  //   showOn: "all",
  // },
  {
    name: "reorderLevel",
    label: "Reorder Level",
    type: "number",
    showOn: "all",
    // required: true,
  },
  {
    name: "expiryDate",
    label: "Expiry Date",
    type: "date",
    showOn: "all",
  },
  {
    name: "supplier",
    label: "Supplier",
    type: "text",
    showOn: "all",
  },
  {
    name: "batchNumber",
    label: "Batch Number",
    type: "text",
    showOn: "all",
  },
  {
    name: "notes",
    label: "Notes",
    type: "textarea",
    showOn: "all",
  },
  // {
  //   name: "created_on",
  //   label: "Created On",
  //   type: "date",
  //   showOn: "view,edit",
  //   disabled: true,
  // },
];
